<template>
<div>
  <Header/>
  <Navigationzj :toptNavi="9"/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200" style="text-align:center;">
      <div class="demo-image__preview" style="margin-top:60px;width:100%;display:inline-block;">
        <div class="l-content" id="top">
          <h1>
            <img src="../../assets/images/scene.gif" alt="欢迎您到志鹏供应链（内蒙古）有限公司" width="1200">
          </h1>
          <!-- h1 标签在此结束 -->
          <div class="l-content-wrap">
            <div class="animation">
              <img src="../../assets/images/ad.png" alt="欢迎您到志鹏供应链（内蒙古）有限公司" class="ad">
              <div class="flag no1">
                <div class="bubble" style="top:0px;transform:scale(1);">
                  <img src="../../assets/images/flag_01.png" alt="标记">
                </div>
                <img src="../../assets/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="tip t1" style="display:none;opacity:0;">
                <div class="row clearfixs">
                  <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_01.png" alt="砂轮及相关产品" class="title">
                  <ul>
                    <li>
                        <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c1.png" alt="金刚石砂轮"></a></span>
                        <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;金刚石砂轮</a></span>
                    </li>
                    <li>
                        <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c2.png" alt="普通砂轮"></a></span>
                        <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;普通砂轮</a></span>
                    </li>
                    <li>
                        <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c3.png" alt="金刚石修正笔"></a></span>
                        <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;金刚石修正笔</a></span>
                    </li>
                  </ul>
                  <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="images/more.png" alt="更多" class="more"></a>
                </div>
              </div>
              <div class="flag no2">
                <div class="bubble" style="top:0px;transform:scale(1);">
                  <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/flag_02.png" alt="标记">
                </div>
                <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="tip t2" style="display:none;opacity:0;">
                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_021.png" alt="动力工具" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3">
                                <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_01.png" alt="微型气动研磨机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;微型气动研磨机</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3">
                                <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_02.png" alt="气动偏心研磨机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;气动偏心研磨机</a></span>
                          </li>
                          <li>
                            <span class="pic">
                              <a href="javascript:void(0)" class="tonav3">
                                <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_03.png" alt="气动砂带机">
                              </a>
                            </span>
                            <span class="name">
                              <a href="javascript:void(0)" class="tonav3">&gt;气动砂带机</a>
                            </span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0800000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>
                  <div class="row clearfixs">
                      <img src="images/icon_022.png" alt="动力工具配套耗材" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="images/t2_04.png" alt="经济型砂轮"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;经济型砂轮</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="images/t2_05.png" alt="干磨黄砂"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;干磨黄砂</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="images/t2_06.png" alt="棕刚玉小砂带"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;棕刚玉小砂带</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>
              </div>
              <div class="flag no3">
                  <div class="bubble" style="top:0px;transform:scale(1);">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/flag_03.png" alt="标记">
                  </div>
                  <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="tip t3" style="display:none;opacity:0;">
                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_01.png" alt="砂轮及相关产品" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c1.png" alt="金刚石砂轮"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;金刚石砂轮</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c2.png" alt="普通砂轮"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;普通砂轮</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav1"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/c3.png" alt="金刚石修正笔"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav1">&gt;金刚石修正笔</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>
                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_04.png" alt="手作业研磨品" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_03.png" alt="金刚石锉刀"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;金刚石锉刀</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_04.png" alt="油石"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;油石</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_05.png" alt="砂纸"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;砂纸</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>
              </div>
              <div class="flag no4">
                  <div class="bubble" style="top:0px;transform:scale(1);">
                      <img src="../../assets/images/flag_04.png" alt="标记">
                  </div>
                  <img src="../../assets/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="tip t4" style="display:none;opacity:0;">
                  <div class="row clearfixs">
                      <img src="images/icon_04.png" alt="手作业研磨品" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="images/t4_01.png" alt="修边器"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;修边器</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="images/t4_02.png" alt="研磨膏"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;研磨膏</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="images/t4_03.png" alt="金刚石锉刀"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;金刚石锉刀</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="images/t4_04.png" alt="油石"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;油石</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="images/t4_05.png" alt="砂纸"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;砂纸</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="images/more.png" alt="更多" class="more"></a>
                  </div>
              </div>
              <div class="flag no5">
                  <div class="bubble" style="top:0px;transform:scale(1);">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/flag_05.png" alt="标记">
                  </div>
                  <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="flag no6">
                  <div class="bubble" style="top:0px;transform:scale(1);">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/flag_06.png" alt="标记">
                  </div>
                  <img src="../../assets/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="flag no7">
                  <div class="bubble" style="top:0px;transform:scale(1);">
                      <img src="../../assets/images/flag_07.png" alt="标记">
                  </div>
                  <img src="../../assets/images/shadow.png" alt="影子" class="shadow">
              </div>
              <div class="tip t7" style="display:block;opacity:1;">
                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_021.png" alt="动力工具" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_01.png" alt="微型气动研磨机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;微型气动研磨机</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_02.png" alt="气动偏心研磨机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;气动偏心研磨机</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_03.png" alt="气动砂带机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;气动砂带机</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav3"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t7_01.png" alt="超静音气动研磨机"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav3">&gt;超静音气动研磨机</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0800000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>

                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_022.png" alt="动力工具配套耗材" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_04.png" alt="经济型砂轮"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;经济型砂轮</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_05.png" alt="干磨黄砂"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;干磨黄砂</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t2_06.png" alt="棕刚玉小砂带"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;棕刚玉小砂带</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav4"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t7_02.png" alt="金刚石锉刀套装"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav4">&gt;金刚石锉刀套装</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>

                  <div class="row clearfixs">
                      <img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/icon_04.png" alt="手作业研磨品" class="title">
                      <ul>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_01.png" alt="修边器"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;修边器</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_02.png" alt="研磨膏"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;研磨膏</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_03.png" alt="金刚石锉刀"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;金刚石锉刀</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_04.png" alt="油石"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;油石</a></span>
                          </li>
                          <li>
                              <span class="pic"><a href="javascript:void(0)" class="tonav2"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/t4_05.png" alt="砂纸"></a></span>
                              <span class="name"><a href="javascript:void(0)" class="tonav2">&gt;砂纸</a></span>
                          </li>
                      </ul>
                      <a href="https://www.misumi.com.cn/vona2/fs_processing/T0500000000/"><img src="https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/more.png" alt="更多" class="more"></a>
                  </div>
              </div>
            </div>
          </div>
          <!--▲LP-html内容请些在此框以内▲-->
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'

export default {
  name: 'Scenehall',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.l-content {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  /* font-family: "Microsoft YaHei", Helvetica, Simsun, Simhei, Arial, sans-serif; */
  font-family: "Microsoft YaHei", Simsun, Simhei;
  color: #000;
  overflow: hidden;
}

ul,
ol {
  list-style: none;
}

.l-content i {
  font-style: normal;
  color: #000;
}

.l-content * {
  margin: 0;
  padding: 0;
  line-height: 1;
  /* transition: all 0.15s;
  -webkit-transition: all 0.15s; */
}

.l-content .clearfixs:after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}

.l-content a {
  text-decoration: none;
}

.l-content img {
  border: 0;
}

.l-content .pricenum {
  color: #DD0000;
  font-family: Arial, sans-serif;
}

.l-content .num {
  font-family: Arial, sans-serif;
}

.l-content .delline {
  position: relative;
}

.l-content .delline::before {
  content: " ";
  position: absolute;
  border-top: 1px solid #FF0000;
  width: 110%;
  top: 50%;
  left: -5%;
  transform: rotate(15deg);
}

.l-content .mail {
  position: relative;
  display: block;
  font-size: 20px;
  width: 477px;
  height: 44px;
  line-height: 44px;
  /* border: 2px solid #D2D2D2; */
  border-radius: 3px;
  font-family: Arial, sans-serif;
  color: #333333;
  background: #f6f6f6;
  padding-left: 41px;
  text-align: center;
  padding: 5px 0;
  border: 1px solid #dddddd;
}

.l-content .mail::before {
  position: absolute;
  left: 29px;
  top: 50%;
  margin-top: -8px;
  content: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/arrow.png);
}

.l-content .l-content-wrap {
  position: relative;
  background: #a0daf2 url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/content_head_bg.png) no-repeat;
  text-align: center;
}

.l-content .l-content-wrap .animation {
  display: block;
  position: absolute;
  top: -887px;
  left: 0;
  width: 1200px;
  height: 887px;
  overflow: hidden;
}

.l-content .l-content-wrap .animation .ad {
  position: absolute;
  top: 0px;
  left: 100px;
  z-index: 20;
}

.l-content .l-content-wrap .animation .ad2 {
  position: absolute;
  left: 630px;
  top: 212px;
  z-index: 20;
}

.l-content .l-content-wrap .animation .flag {
  position: absolute;
  width: 61px;
  height: 103px;
  line-height: 86px;
  margin-top: -51px;
  margin-left: -30px;
  z-index: 10;
}

.l-content .l-content-wrap .animation .flag .bubble {
  position: absolute;
  top: 0;
  transition: all 0.7s;
  -moz-transition: all 0.7s;
  /* Firefox 4 */
  -webkit-transition: all 0.7s;
  /* Safari 和 Chrome */
  -o-transition: all 0.7s;
  /* Opera */
}

.l-content .l-content-wrap .animation .flag .shadow {
  position: absolute;
  bottom: 0px;
  left: 18px;
}

.l-content .l-content-wrap .animation .flag span {
  position: absolute;
  top: 0px;
  left: 0px;
}

.l-content .l-content-wrap .animation .flag span {
  display: block;
  width: 61px;
  height: 86px;
  line-height: 86px;
  text-align: center;
  padding-top: 20px;
}

.l-content .l-content-wrap .animation .flag span strong {
  margin: auto;
  font-size: 14px;
  font-weight: 900;
  line-height: 17px;
  cursor: default;
}

.l-content .l-content-wrap .animation .flag.no1 {
  left: 262px;
  top: 556px;
}

.l-content .l-content-wrap .animation .tip {
  position: absolute;
  z-index: 20;
  padding-top: 35px;
  display: none;
  opacity: 0;

  transition: opacity 1s;
  -moz-transition: opacity 1s;
  /* Firefox 4 */
  -webkit-transition: opacity 1s;
  /* Safari 和 Chrome */
  -o-transition: opacity 1s;
  /* Opera */
}

.l-content .l-content-wrap .animation .tip .row {
  /* height: 127px; */
  margin-left: 5px;
}

.l-content .l-content-wrap .animation .tip .row:not(:first-child)::before {
  content: " ";
  display: block;
  margin: 5px 30px 5px 0;
  border-bottom: 2px solid #999999;

}

.l-content .l-content-wrap .animation .tip .row .title,
.l-content .l-content-wrap .animation .tip .row ul,
.l-content .l-content-wrap .animation .tip .row .more {
  float: left;
}

.l-content .l-content-wrap .animation .tip .row ul {
  margin: 0 26px;
}

.l-content .l-content-wrap .animation .tip .row ul li {
  float: left;
}

.l-content .l-content-wrap .animation .tip .row ul li:not(:last-child) {
  margin-right: 8px;
}

.l-content .l-content-wrap .animation .tip .row ul li span {
  display: block;
}

.l-content .l-content-wrap .animation .tip .row ul li span.name {
  width: 99px;
  text-align: center;
}

.l-content .l-content-wrap .animation .tip .row ul li span.name a {
  font-size: 14px;
  color: #000000;
  text-decoration: underline;
}

.l-content .l-content-wrap .animation .tip .row ul li span.pic {
  position: relative;
  font-size: 0;
  width: 99px;
  height: 90px;
}

.l-content .l-content-wrap .animation .tip .row ul li span.pic img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  margin: auto;
}

.l-content .l-content-wrap .animation .tip .row .more {
  margin-top: 24px;
}

.l-content .l-content-wrap .animation .tip.t1 {
  background: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/b_bg1.png) no-repeat;
  left: 207px;
  top: 609px;
  width: 600px;
  padding-bottom: 10px;
}

.l-content .l-content-wrap .animation .tip.t2 {
  background: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/b_bg2.png) no-repeat;
  left: 310px;
  top: 497px;
  width: 595px;
  padding-bottom: 10px;
}
.l-content .l-content-wrap .animation .tip.t2 .row ul {
  margin: 0px 9px;
}

.l-content .l-content-wrap .animation .tip.t2 .row ul li span.pic,
.l-content .l-content-wrap .animation .tip.t2 .row ul li span.name {
  width: 110px;
}

.l-content .l-content-wrap .animation .tip.t3 {
  background: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/b_bg3.png) no-repeat;
  left: 313px;
  top: 233px;
  width: 595px;
  height: 310px;
  padding-top: 12px;
}

.l-content .l-content-wrap .animation .tip.t3 .row ul li span.pic,
.l-content .l-content-wrap .animation .tip.t3 .row ul li span.name {
  width: 96px;
}

.l-content .l-content-wrap .animation .tip.t4 {
  background: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/b_bg4.png) no-repeat;
  left: 200px;
  top: 545px;
  width: 850px;
  display: none;
}

.l-content .l-content-wrap .animation .tip.t4 .row ul li span.pic,
.l-content .l-content-wrap .animation .tip.t4 .row ul li span.name {
  width: 105px;
}

.l-content .l-content-wrap .animation .tip.t7 {
  background: url(https://www.misumi.com.cn/pr/vona/fs/yanmo_201910/images/b_bg7.png) no-repeat;
  left: 199px;
  top: 440px;
  width: 850px;
  height: 483px;
  display: none;
}

.l-content .l-content-wrap .animation .tip.t7 .row ul li span.pic,
.l-content .l-content-wrap .animation .tip.t7 .row ul li span.name {
  width: 135px;
}

.l-content .l-content-wrap .animation .tip.t7 .row:last-child ul li span.pic,
.l-content .l-content-wrap .animation .tip.t7 .row:last-child ul li span.name {
  width: 106px;
}

.l-content .l-content-wrap .animation .flag.no2 {
  left: 423px;
  top: 443px;
}

.l-content .l-content-wrap .animation .flag.no3 {
  left: 670px;
  top: 595px;
}

.l-content .l-content-wrap .animation .flag.no3 span {
  padding-top: 10px !important;

}

.l-content .l-content-wrap .animation .flag.no4 {
  left: 1090px;
  top: 400px;
}

.l-content .l-content-wrap .animation .flag.no5 {
  left: 640px;
  top: 210px;
}

.l-content .l-content-wrap .animation .flag.no5 *:hover,
.l-content .l-content-wrap .animation .flag.no6 *:hover {
  cursor: pointer;
}

.l-content .l-content-wrap .animation .flag.no5 span {
  padding-top: 30px !important;
  font-family: Arial, sans-serif;

}

.l-content .l-content-wrap .animation .flag.no6 {
  left: 810px;
  top: 290px;
}

.l-content .l-content-wrap .animation .flag.no7 {
  left: 910px;
  top: 200px;
}

.l-content .l-content-wrap .move .ship {
  position: absolute;
  /* left:-23px;
    top:331px; */
  left: 36px;
  top: 290px;
  margin: -23px 0 0 -20px;
  z-index: 5;
}

.l-content .l-content-wrap .move .train {
  position: absolute;
  left: 1200px;
  top: 376px;
  z-index: 5;
}

.l-content .l-content-wrap .move .car {
  position: absolute;
}

.l-content .l-content-wrap .move .car img {
  margin-left: -32px;
  margin-top: -25px;
}

.l-content .l-content-wrap .move .car.cno1 {
  left: 226px;
  top: 486px;
}

.l-content .l-content-wrap .move .car.cno2 {
  left: 816px;
  top: 147px;
}

.l-content .l-content-wrap .move .car.cno3 {
  left: 611px;
  top: 586px;
}

.l-content .l-content-wrap .move .car.cno4 {
  left: 404px;
  top: -35px;
}

.l-content .l-content-wrap .move .car.cno5 {
  left: 491px;
  top: 461px;
}

.l-content .l-content-wrap .move .car.cno6 {
  left: -36px;
  top: 622px;
}

.l-content .l-content-wrap .trans16 {
  transition: all 16s linear;
  -moz-transition: all 16s linear;
  /* Firefox 4 */
  -webkit-transition: all 16s linear;
  /* Safari 和 Chrome */
  -o-transition: all 16s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans12 {
  transition: all 12s linear;
  -moz-transition: all 12s linear;
  /* Firefox 4 */
  -webkit-transition: all 12s linear;
  /* Safari 和 Chrome */
  -o-transition: all 12s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans10 {
  transition: all 10s linear;
  -moz-transition: all 10s linear;
  /* Firefox 4 */
  -webkit-transition: all 10s linear;
  /* Safari 和 Chrome */
  -o-transition: all 10s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans8 {
  transition: all 8s linear;
  -moz-transition: all 8s linear;
  /* Firefox 4 */
  -webkit-transition: all 8s linear;
  /* Safari 和 Chrome */
  -o-transition: all 8s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans6 {
  transition: all 6s linear;
  -moz-transition: all 6s linear;
  /* Firefox 4 */
  -webkit-transition: all 6s linear;
  /* Safari 和 Chrome */
  -o-transition: all 6s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans4 {
  transition: all 4s linear;
  -moz-transition: all 4s linear;
  /* Firefox 4 */
  -webkit-transition: all 4s linear;
  /* Safari 和 Chrome */
  -o-transition: all 4s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans3 {
  transition: all 3s linear;
  -moz-transition: all 3s linear;
  /* Firefox 4 */
  -webkit-transition: all 3s linear;
  /* Safari 和 Chrome */
  -o-transition: all 3s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans2 {
  transition: all 2s linear;
  -moz-transition: all 2s linear;
  /* Firefox 4 */
  -webkit-transition: all 2s linear;
  /* Safari 和 Chrome */
  -o-transition: all 2s linear;
  /* Opera */
}

.l-content .l-content-wrap .trans1 {
  transition: all 1s linear;
  -moz-transition: all 1s linear;
  /* Firefox 4 */
  -webkit-transition: all 1s linear;
  /* Safari 和 Chrome */
  -o-transition: all 1s linear;
  /* Opera */
}
</style>



// WEBPACK FOOTER //
// src/view/scenehall/index.vue